import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { BatchSummaryDTO } from "models";
import { Layout } from "pages/Generation/models";

type InitialState = {
  layout: Layout;
  generationStatus: string;
  batchesSummary: BatchSummaryDTO[];
  isRequeryFinalStatusModalOpen: boolean;
  isInvalidateFinalStatusModalOpen: boolean;
  isRevalidateFinalStatusModalOpen: boolean;
  isRequeryMultipleBatchDrawerOpen: boolean;
  isInvalidateMultipleBatchDrawerOpen: boolean;
};

const initialState: InitialState = {
  batchesSummary: [],
  generationStatus: "pending",
  isRequeryFinalStatusModalOpen: false,
  isRequeryMultipleBatchDrawerOpen: false,
  isInvalidateFinalStatusModalOpen: false,
  isRevalidateFinalStatusModalOpen: false,
  isInvalidateMultipleBatchDrawerOpen: false,
  layout: { title: "", path: "", function: "" },
};

const generationSlice = createSlice({
  name: "data-generation",
  initialState: initialState,

  reducers: {
    updateGenerationStatus: (state, action: PayloadAction<string>) => {
      state.generationStatus = action.payload;
    },

    setBatchesSummary: (state, action: PayloadAction<BatchSummaryDTO[]>) => {
      state.batchesSummary = action.payload;
    },

    updateLayout: (state, action: PayloadAction<Layout>) => {
      state.layout = action.payload;
    },

    setIsRequeryFinalStatusModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isRequeryFinalStatusModalOpen = action.payload;
    },

    setIsRequeryMultipleBatchDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isRequeryMultipleBatchDrawerOpen = action.payload;
    },
    setIsInvalidateMultipleBatchDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isInvalidateMultipleBatchDrawerOpen = action.payload;
    },

    setIsInvalidateFinalStatusModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isInvalidateFinalStatusModalOpen = action.payload;
    },

    setIsRevalidateFinalStatusModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isRevalidateFinalStatusModalOpen = action.payload;
    },
  },
});

export default generationSlice.reducer;
export const {
  updateLayout,
  setBatchesSummary,
  updateGenerationStatus,
  setIsRequeryFinalStatusModalOpen,
  setIsInvalidateFinalStatusModalOpen,
  setIsRevalidateFinalStatusModalOpen,
  setIsRequeryMultipleBatchDrawerOpen,
  setIsInvalidateMultipleBatchDrawerOpen,
} = generationSlice.actions;
